import React from "react";
import { useStaticQuery, graphql } from 'gatsby';

const MetaHead = ({title, description, image}) => {

    const { site } = useStaticQuery(
        graphql`
          query {
            site {
                siteMetadata {
                    siteUrl
                }
            }
          }
        `,
        );

    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    
    return (
        <>
            <title>{title}</title>
            <meta name="description" content={description}/>
            <meta name="image" content={image}/>
            <meta property="og:title" content={title} />
            <meta property="og:type" content="website" />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={`${site.siteMetadata?.siteUrl}${pathname}`} />
            <meta property="og:image" content={image} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@infolabuk" />
            <meta property="og:site_name" content="The Information Lab"></meta>
        </>
)}

export default MetaHead;